import "core-js/stable";
import "regenerator-runtime/runtime";
// Jquery
import jQuery from "jquery";
window.jQuery = jQuery;
window.$ = jQuery;
// Poppper
import 'popper.js';
// Bootstrap
import 'bootstrap';
// Font awesome
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';
// Theme
import '../scss/app.scss';

// Tooltip
$(function () {
	// Default configuration
	var _tooltip = $.fn.tooltip;
	$.fn.tooltip = function(options){
		return _tooltip.apply(this, [{
			html: true
		}]);
	};
	// Apply tooltip on all elements
	$('[data-toggle="tooltip"]').tooltip();
});
